(function() {
    $(document).ready(function() {

        const c24SlideDown = $('.c24SlideDown');

        if (!c24SlideDown.length) {
            return;
        }

        $('.box24Close', c24SlideDown).on('click', function(e) {
            e.preventDefault();
            $(e.target).closest('.c24SlideDown').stop().slideUp('slow');
        });

        $('.c24SlideDownInfo').on('click', function() {
            $('#' + $(this).data('content-id')).stop().slideToggle('fast');
        });
    });
})();
